import { render, staticRenderFns } from "./AgentQuickResponse.vue?vue&type=template&id=a873fbc2&scoped=true"
import script from "./AgentQuickResponse.vue?vue&type=script&lang=js"
export * from "./AgentQuickResponse.vue?vue&type=script&lang=js"
import style0 from "./AgentQuickResponse.vue?vue&type=style&index=0&id=a873fbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a873fbc2",
  null
  
)

export default component.exports